export default "__VITE_ASSET__B81o0Gsm__"